// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Projects Page Styles */

/* Action Feedback */
.action-feedback {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  z-index: 2000;
  animation: slideIn 0.3s ease;
  max-width: 400px;
}

.action-feedback.success {
  border-left: 4px solid #28a745;
}

.action-feedback.error {
  border-left: 4px solid #dc3545;
}

.action-feedback.info {
  border-left: 4px solid #17a2b8;
}

.action-feedback button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #6c757d;
}

.action-feedback button:hover {
  color: #343a40;
}

/* Button Group */
.button-group {
  display: flex;
  gap: 12px;
}

/* Search Container */
.search-containers {
  margin-bottom: 15px;
  position: relative;
  max-width: 300px;
  margin-top: 15px;
}

/* Sortable Headers */
.sortable-header {
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}

.sortable-header:hover {
  background-color: rgba(79, 70, 229, 0.05);
}

.sortable-header .flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.sortable-header svg {
  margin-left: 4px;
  transition: color 0.2s ease;
}

.import-jira-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: var(--bg-light);
  border-color: var(--primary);
  color: var(--primary);
  border: 1px solid var(--border-color);
  transition: all 0.2s ease;
}

/* .import-jira-btn:hover {
  background-color: var(--bg-light);
  border-color: var(--primary);
  color: var(--primary);
} */

.import-jira-btn svg {
  color: var(--primary);
}

/* Action Buttons */
.action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn {
   flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background-color: var(--bg-light);
  color: var(--text-primary);
}

.action-btn.view:hover {
  color: #17a2b8;
}

.action-btn.edit:hover {
  color: #28a745;
}

.action-btn.delete:hover {
  color: #dc3545;
}

.action-btn.more {
  position: relative;
}

 
.action-dropdown {
  position: absolute;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 160px;
  padding: 8px 0;
  z-index: 1000;
  max-height: min(360px, calc(100vh - 24px));
  overflow-y: auto;
  overflow-x: hidden;
}

.action-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  color: var(--text-primary);
  text-decoration: none;
  font-size: 14px;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  background-color: var(--surface);
}

/* .projects-table tr:nth-last-child(-n+3) .action-dropdown {
  bottom: 100%;
  top: auto;
  margin-top: 0;
  margin-bottom: 5px;
} */


.action-dropdown.dropdown-above {
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
}

.dropdown-last-rows {
  bottom: 100%;
  top: auto !important;
  margin-top: 0 !important;
}

.action-dropdown.active {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
}

.action-dropdown-divider {
  height: 1px;
  background-color: #eee;
  margin: 0.25rem 0;
}

.action-btn-container {
  position: relative;
  display: inline-block;
}

.action-btn-container:hover .action-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
}

.action-dropdown:hover {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
}

/* Submenu Styles */
.action-dropdown-item-with-submenu {
  position: relative;
}

.action-dropdown-item.has-submenu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  width: 100%;
}

.action-dropdown-item.has-submenu .flex-1 {
  flex: 1 1;
  text-align: left;
}

.submenu-arrow {
  margin-left: 8px;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.submenu-arrow.open {
  transform: rotate(90deg);
}

.action-submenu {
  position: static;
  background-color: #f8f9fa;
  border-radius: 0;
  box-shadow: none;
  min-width: 0;
  width: 100%;
  padding: 0;
  margin: 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  z-index: auto;
  animation: none;
}

.action-submenu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 8px 36px;
  color: var(--text-primary);
  text-decoration: none;
  font-size: 14px;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.15s ease;
}

.action-submenu-item:hover:not(:disabled) {
  background-color: #f8f9fa;
  color: var(--primary);
}

.action-submenu-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-submenu-item:disabled:hover {
  background-color: var(--surface);
  color: var(--text-primary);
}

.submenu-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.status-active {
  background-color: #e6f4ea;
  color: #28a745;
}

.status-badge.status-inactive {
  background-color: #f8d7da;  
  color: #dc3545;    
}

.status-badge.status-completed {
  background-color: #cff4fc;
  color: #0dcaf0;
}

.status-badge.status-archived {
  background-color: #f8d7da;
  color: #dc3545;
}

/* JIRA Status Badge Colors */
.status-badge.status-todo {
  background-color: #e3f2fd;
  color: #1976d2;
}

.status-badge.status-inprogress {
  background-color: #fff3e0;
  color: #f57c00;
}

.status-badge.status-done {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.status-badge.status-blocked {
  background-color: #ffebee;
  color: #c62828;
}

/* Projects Table */


.projects-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  table-layout: fixed;
}


.projects-table td:last-child {
  overflow: visible !important;
}

.projects-table th {
  background-color: #f8f9fa;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-color);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}

.projects-table th:hover {
  background-color: #e9ecef;
}

.projects-table tr:last-child td {
  border-bottom: none;
}

.projects-table tr:hover {
  background-color: #f8f9fa;
  position: relative; /* Add position relative */
  z-index: 1; /* Lower z-index than the dropdown */
}

/* Ensure the last cell in each row has a higher z-index */
.projects-table tr td:last-child {
  position: relative;
  z-index: 50;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-top: 24px;
}

.empty-state-icon {
  color: #dee2e6;
  margin-bottom: 24px;
}

.empty-state-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--text-primary);
}

.empty-state-description {
  color: var(--text-muted);
  margin-bottom: 24px;
  max-width: 400px;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.projects-container {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  padding: 1rem;
  box-sizing: border-box;
}

/* Viewport-fit layout: only the table scrolls; pagination stays on-screen */
.projects-container.projects-list-layout {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 0;
  overflow: visible;
}

.projects-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.projects-container.projects-list-layout .projects-header {
  flex-shrink: 0;
}

.projects-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--text-dark);
  margin: 0;
}

.projects-subtitle {
  font-size: 1rem;
  color: var(--text-muted);
  margin-top: 0.5rem;
}

.projects-actions {
  display: flex;
  gap: 1rem;
}

/* Filter and Search Section */
.projects-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filter-label {
  font-weight: 500;
  color: var(--text-dark);
  white-space: nowrap;
}

.filter-select {
  padding: 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  min-width: 150px;
  font-size: 0.9rem;
}

.search-box {
  flex-grow: 1;
  position: relative;
}

.search-box input {
  width: 100%;
  padding: 0.5rem 0.75rem 0.5rem 2.25rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 0.9rem;
}

.search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
}

/* Projects Table */
.projects-table-container {
  position: relative;
  z-index: 1;

  width: 100%;
  margin: 0 0 1rem 0;

  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);

  min-height: 200px;
  max-height: 500px;

  overflow-y: auto;
  overflow-x: auto;

  -webkit-overflow-scrolling: touch;
}

/* Fill remaining viewport so only the table scrolls; pagination stays visible */
.projects-container.projects-list-layout > .projects-table-container {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
}

.projects-table {
  width: 100%;
  border-collapse: collapse;
  flex: 1 1;
  height: auto; /* Auto height based on content */
  min-height: 100px; /* Minimum height */
  table-layout: fixed; /* Fixed table layout for better control */
}

.projects-table th,
.projects-table td {
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color-light);
  position: static;
}

.projects-table td .cell-truncate {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.projects-table .column-name {
  white-space: normal;
  overflow: hidden;
}

.projects-table .project-name-text {
  font-weight: 500;
}

.projects-table .project-description-text {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.projects-table .column-actions,
.projects-table .column-actions .action-buttons {
  overflow: visible;
  white-space: nowrap;
  text-overflow: clip;
}

.projects-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #f8f9fa;
}

.projects-table tbody {
  /* overflow-y: auto; */
  position: relative;
  z-index: 1;
}

.projects-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: var(--text-dark);
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.projects-table td:not(.column-name):not(.column-actions) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.projects-table th.column-srno,
.projects-table td.column-srno {
  width: 5%;
  min-width: 50px;
  text-align: center;
}

.projects-table th.column-name,
.projects-table td.column-name {
  width: 22%;
  min-width: 140px;
}

.projects-table th.column-type,
.projects-table td.column-type,
.projects-table th.column-status,
.projects-table td.column-status {
  width: 8%;
  min-width: 72px;
  text-align: center;
}

.projects-table th.column-testcases,
.projects-table td.column-testcases {
  width: 7%;
  min-width: 72px;
  text-align: center;
}

.projects-table th.column-createdby,
.projects-table td.column-createdby {
  width: 11%;
  min-width: 90px;
}

.projects-table th.column-created,
.projects-table td.column-created,
.projects-table th.column-updated,
.projects-table td.column-updated {
  width: 11%;
  min-width: 100px;
}

.projects-table th.column-actions,
.projects-table td.column-actions {
  width: 148px;
  min-width: 148px;
  max-width: 148px;
  text-align: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  overflow: visible;
}

.projects-table .column-actions .action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
  margin: 0;
}

.projects-table th:hover {
  background-color: #f1f3f5;
}

.sort-icon {
  margin-left: 0.25rem;
  display: inline-block;
  transition: transform 0.2s ease;
}

.sort-asc .sort-icon {
  transform: rotate(180deg);
}

.projects-table tbody tr {
  transition: background-color 0.2s ease;
}

.projects-table tbody tr:hover {
  background-color: rgba(66, 133, 244, 0.05);
}

/* Project Status Badges */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
}

.status-active {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.status-draft {
  background-color: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

.status-completed {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
}

.status-archived {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

/* Test Cases and Pass Rate Styles */
.test-cases-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  min-width: 40px;
}

.pass-rate-high {
  color: #28a745;
}

.pass-rate-medium {
  color: #fd7e14;
}

.pass-rate-low {
  color: #dc3545;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  flex-wrap: nowrap;
   gap: 0.25rem;
   justify-content: flex-start;


}

.action-btn {
   flex-shrink: 0;
   background: none;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-muted);
  transition: all 0.3s ease;
}

.action-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: var(--text-dark);
}

.action-btn.edit:hover {
  color: #0d6efd;
}

.action-btn.delete:hover {
  color: #dc3545;
}

.action-btn.view:hover {
  color: #20c997;
}

.action-dropdown-item:hover {
  background-color: #f8f9fa;
}

.action-dropdown-item-wrapper {
  width: 100%;
}

.action-dropdown-item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.action-dropdown-item:disabled:hover {
  background-color: transparent;
}

/* Add a pseudo-element to create a larger hit area and prevent dropdown from closing */
/* .action-btn.more::after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  display: none;
} */

/* .action-btn.more:focus::after,
.action-btn.more:hover::after {
  display: block;
}  */
 
/* Ensure the action button has position relative for proper dropdown positioning */
 

/* Improve dropdown visibility behavior */

/* Keep the old hover behavior as a fallback */
 

/* Ensure the table row doesn't interfere with the dropdown */
.projects-table tr:hover {
  z-index: auto !important;
  position: static !important;
}

/* Fix for dropdown positioning */
.projects-table td:last-child {
  position: relative !important;
  overflow: visible !important; /* Ensure dropdown isn't cut off */
}

/* Add a container to ensure proper stacking context */
/* Container for action buttons */
.action-buttons {
  position: relative;
  z-index: 10;
}

 

/* Dropdown menu container */
.dropdown-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2); /* subtle darkening */
  z-index: 9998; /* below the dropdown but above content */
}

/* Prevent dropdown from being cut off in rows */
.projects-table tr {
  position: relative;
  z-index: 1; /* Normal stacking level */
}


/* Pagination */
.projects-container.projects-list-layout > .pagination-container {
  flex-shrink: 0;
}

.pagination {
  display: flex;
  align-items: center;
  margin-top: auto;
  padding: 1rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.pagination-info {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.pagination-controls {
  display: flex;
  gap: 0.5rem;
}

.pagination-btn {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 999px;
  background-color: transparent;
  color: var(--text-secondary, var(--text-dark));
  cursor: pointer;
  transition: all 0.2s ease;
}

.pagination-btn:hover {
  background-color: var(--surface-hover, #f8f9fa);
  color: var(--text-primary, var(--text-dark));
}

.pagination-btn.active {
  background-color: var(--primary-muted, rgba(37, 99, 235, 0.1));
  color: var(--primary, var(--primary-color));
  border-color: transparent;
}

.pagination-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
}

.empty-state-icon {
  font-size: 4rem;
  color: var(--border-color);
  margin-bottom: 1rem;
}

.empty-state-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}

.empty-state-description {
  color: var(--text-muted);
  margin-bottom: 1.5rem;
  max-width: 400px;
}

/* Responsive Styles */
@media (max-width: 992px) {
  .projects-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .projects-actions {
    width: 100%;
  }
  
  .projects-filters {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .filter-group {
    width: 100%;
  }
  
  .filter-select {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .projects-container {
    padding: 0.5rem;
    height: auto;
    min-height: 100vh;
  }

  .projects-container.projects-list-layout {
    height: auto;
    min-height: 0;
    overflow: visible;
  }
  
  .projects-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  
  .projects-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .projects-filters {
    padding: 0.75rem;
  }
  
  .projects-table-container {
    height: auto;
    min-height: 200px;
    max-height: none;
    overflow-x: auto;
    margin-bottom: 1rem;
  }

  .projects-container.projects-list-layout > .projects-table-container {
    min-height: 0;
    max-height: none;
  }
  
  .projects-table {
    font-size: 0.9rem;
  }
  
  .projects-table .action-buttons {
    flex-wrap: nowrap;
  }
  
  .pagination {
    flex-direction: column;
    gap: 1rem;
  }
}

/* Table Responsive Behavior */
@media (max-width: 1400px) {
  .projects-container {
    padding: 1rem;
  }

  .projects-table th.column-name,
  .projects-table td.column-name {
    width: 18%;
    min-width: 120px;
  }

  .projects-table th.column-actions,
  .projects-table td.column-actions {
    width: 148px;
    min-width: 148px;
    max-width: 148px;
  }
}

/* Card View for Mobile */
@media (max-width: 576px) {
  .projects-container {
    padding: 0.5rem;
    width: 100%;
    overflow-x: hidden;
  }
  
  .projects-table-container {
    display: none;
  }
  
  .projects-cards {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    margin-top: 1rem;
  }
  
  .project-card {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 1rem;
    width: 100%;
    box-sizing: border-box;
  }
  
  .project-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1rem;
  }
  
  .project-card-title {
    font-weight: 600;
    font-size: 1.1rem;
    color: var(--text-dark);
    margin: 0;
  }
  
  .project-card-content {
    display: grid;
    grid-template-columns: minmax(100px, auto) 1fr;
    gap: 0.75rem 1rem;
    margin-bottom: 1rem;
    width: 100%;
  }
  
  .project-card-label {
    font-weight: 500;
    color: var(--text-muted);
    white-space: nowrap;
  }
  
  .project-card-value {
    color: var(--text-dark);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .project-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--border-color-light);
    padding-top: 1rem;
    width: 100%;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  
  .project-card-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
  
  /* Mobile card specific styles for test cases and pass rate */
  .project-card-value .test-cases-badge {
    font-size: 0.8rem;
    padding: 2px 8px;
  }
  
  .project-card-value .progress-bar-container {
    width: 50px;
    height: 6px;
    background-color: #e9ecef;
    border-radius: 3px;
    overflow: hidden;
  }
  
  .project-card-value .progress-bar {
    height: 100%;
    border-radius: 3px;
  }
  
  .project-card-value .progress-bar.high {
    background-color: #28a745;
  }
  
  .project-card-value .progress-bar.medium {
    background-color: #fd7e14;
  }
  
  .project-card-value .progress-bar.low {
    background-color: #dc3545;
  }
}

/* Status Tabs Container */
.status-tabs-container {
  margin: 0.75rem 0 1rem 0;
  /* padding: 0 0.5rem; */
}

.projects-container.projects-list-layout .status-tabs-container {
  flex-shrink: 0;
}

.status-tabs {
  display: flex;
  gap: 1px;
  background-color: #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.status-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  border: none;
  background-color: white;
  color: #666;
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  min-width: 100px;
}

.status-tab:hover {
  background-color: #f5f5f5;
}

.status-tab.active {
  background-color: #4361ee;
  color: white;
  font-weight: 600;
}

.tab-label {
  margin-right: 8px;
}

.tab-count {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 0.8rem;
  font-weight: 500;
}

.status-tab.active .tab-count {
  background-color: rgba(255, 255, 255, 0.2);
}

/* Dark mode support */
.dark-mode .status-tabs {
  background-color: #333;
}

.dark-mode .status-tab {
  background-color: #2d2d2d;
  color: #ccc;
}

.dark-mode .status-tab:hover {
  background-color: #3a3a3a;
}

.dark-mode .status-tab.active {
  background-color: #4361ee;
  color: white;
}

.dark-mode .tab-count {
  background-color: rgba(255, 255, 255, 0.1);
}

.search-input::placeholder {
  color: gray;
  opacity: 1; 
}

.no-projects-message {
  text-align: center;
  padding: 2rem;
  color: var(--text-muted);
  font-size: 1.1rem;
}

.projects-table td > div[title],
.projects-table td .cell-truncate[title] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  cursor: default;
}

.projects-table td > div[title]:hover::after,
.projects-table td .cell-truncate[title]:hover::after {
  content: attr(title);
  position: absolute;
  left: 0;
  top: 100%;
  background: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
  z-index: 1000;
  white-space: normal;
  max-width: 300px;
  word-wrap: break-word;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}

.projects-table .column-name td > div[title]:first-child:hover::after,
.projects-table td.column-name .cell-truncate:first-child:hover::after {
  top: auto;
  bottom: 100%;
  left: 0;
}

.projects-table td:has(.cell-truncate[title]):hover,
.projects-table td:has(> div[title]):hover {
  overflow: visible;
  z-index: 5;
}

.projects-table td .cell-truncate[title],
.projects-table td > div[title] {
  position: relative;
}

@media (max-width: 768px) {
  .projects-table td > div[title]:hover::after {
    font-size: 0.8rem;
    max-width: 200px;
    padding: 0.4rem 0.6rem;
  }
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.projects-table {
  width: 100%;
}


.column-srno { width: 5%; min-width: 50px; }
.column-name { width: 22%; min-width: 140px; }
.column-type { width: 8%; min-width: 72px; }
.column-status { width: 8%; min-width: 72px; }
.column-testcases { width: 7%; min-width: 72px; }
.column-createdby { width: 11%; min-width: 90px; }
.column-created { width: 11%; min-width: 100px; }
.column-updated { width: 11%; min-width: 100px; }
.column-actions { width: 148px; min-width: 148px; max-width: 148px; }


.projects-cards-container {
  display: none;
}


@media screen and (max-width: 1400px) {
  .projects-table {
    font-size: 0.9rem;
  }

  .projects-table th,
  .projects-table td {
    padding: 0.75rem;
  }
}

@media screen and (max-width: 1200px) {
  .projects-table-container {
    overflow-x: auto;
  }

  .projects-cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1rem;
  }

  .project-card {
    background: var(--surface);
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.75rem;
  }

  .card-title {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 500;
    flex: 1 1;
    margin-right: 0.5rem;
  }

  .card-description {
    color: var(--text-muted);
    margin-bottom: 1rem;
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .card-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .card-detail-item {
    display: flex;
    flex-direction: column;
  }

  .detail-label {
    font-size: 0.8rem;
    color: var(--text-muted);
    margin-bottom: 0.25rem;
  }

  .detail-value {
    font-size: 0.9rem;
    font-weight: 500;
  }

  .card-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }
}


@media screen and (max-width: 768px) {
  .projects-cards-container {
    grid-template-columns: 1fr;
  }
  
  .projects-header {
    flex-direction: column;
    gap: 1rem;
  }
  
  .status-tabs {
    flex-wrap: wrap;
  }
  
  .status-tab {
    flex: 1 0 45%;
    margin-bottom: 0.5rem;
  }
}


@media screen and (min-resolution: 200dpi) {
  .projects-table {
    font-size: 0.9rem;
  }
  
  .projects-table th,
  .projects-table td {
    padding: 0.5rem 0.75rem;
  }
}


.progress-bar-container {
  width: 60px;
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

/* Epics/Stories Page Search Styles */
.projects-container .navbar-search {
  position: relative;
  width: 300px;
  max-width: 100%;
}

.projects-container .navbar-search input {
  width: 100%;
  padding: 0.5rem 0.75rem 0.5rem 2.25rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: white;
  color: #333;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.projects-container .navbar-search input::placeholder {
  color: #999;
}

.projects-container .navbar-search input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.projects-container .navbar-search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  pointer-events: none;
  z-index: 1;
}

/* Generate Tests Button Styles */
.generate-tests-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;
}

.generate-tests-btn:hover:not(.loading) {
  background-color: #0056b3;
}

.generate-tests-btn.loading {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Spin animation for loading spinner */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
  flex-wrap: nowrap;
}


.status-badge {
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem;
}

`, "",{"version":3,"sources":["webpack://./src/styles/projects.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,oBAAoB;AACpB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,4BAA4B;EAC5B,qBAAqB;EACrB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;;;;GAIG;;AAEH;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;GACG,cAAc;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;;;GAKG;;;AAGH;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,6BAA6B;EAC7B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;;;AAGnB;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,4CAA4C;EAC5C,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB,EAAE,0BAA0B;EAC9C,UAAU,EAAE,oCAAoC;AAClD;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;;EAEV,WAAW;EACX,kBAAkB;;EAElB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;;EAEtC,iBAAiB;EACjB,iBAAiB;;EAEjB,gBAAgB;EAChB,gBAAgB;;EAEhB,iCAAiC;AACnC;;AAEA,gFAAgF;AAChF;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,SAAO;EACP,YAAY,EAAE,iCAAiC;EAC/C,iBAAiB,EAAE,mBAAmB;EACtC,mBAAmB,EAAE,0CAA0C;AACjE;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;EAChB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;EAIE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;;;;EAIE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,iBAAiB;GAChB,YAAY;GACZ,2BAA2B;;;AAG9B;;AAEA;GACG,cAAc;GACd,gBAAgB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,uFAAuF;AACvF;;;;;;;;;GASG;;AAEH;;;IAGI;;AAEJ,mFAAmF;;;AAGnF,yCAAyC;;AAEzC,8CAA8C;;;AAG9C,6DAA6D;AAC7D;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,4BAA4B,EAAE,kCAAkC;AAClE;;AAEA,sDAAsD;AACtD,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;AACb;;;;AAIA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B,EAAE,qBAAqB;EACrD,aAAa,EAAE,yCAAyC;AAC1D;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,UAAU,EAAE,0BAA0B;AACxC;;;AAGA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,6BAA6B;EAC7B,8CAA8C;EAC9C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,8DAA8D;EAC9D,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,UAAU;IACV,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8CAA8C;IAC9C,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,+CAA+C;IAC/C,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA,6DAA6D;EAC7D;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,+BAA+B;EAC/B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;;EAEE,SAAS;EACT,YAAY;EACZ,OAAO;AACT;;AAEA;;EAEE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;;AAGA,eAAe,SAAS,EAAE,eAAe,EAAE;AAC3C,eAAe,UAAU,EAAE,gBAAgB,EAAE;AAC7C,eAAe,SAAS,EAAE,eAAe,EAAE;AAC3C,iBAAiB,SAAS,EAAE,eAAe,EAAE;AAC7C,oBAAoB,SAAS,EAAE,eAAe,EAAE;AAChD,oBAAoB,UAAU,EAAE,eAAe,EAAE;AACjD,kBAAkB,UAAU,EAAE,gBAAgB,EAAE;AAChD,kBAAkB,UAAU,EAAE,gBAAgB,EAAE;AAChD,kBAAkB,YAAY,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;;AAGpE;EACE,aAAa;AACf;;;AAGA;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,SAAO;IACP,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,WAAW;EACb;AACF;;;AAGA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;AACF;;;AAGA;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAuB;EACzB;AACF;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;EACjB,uBAAuB;AACzB","sourcesContent":["/* Projects Page Styles */\n\n/* Action Feedback */\n.action-feedback {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 12px 20px;\n  border-radius: 4px;\n  background-color: white;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  z-index: 2000;\n  animation: slideIn 0.3s ease;\n  max-width: 400px;\n}\n\n.action-feedback.success {\n  border-left: 4px solid #28a745;\n}\n\n.action-feedback.error {\n  border-left: 4px solid #dc3545;\n}\n\n.action-feedback.info {\n  border-left: 4px solid #17a2b8;\n}\n\n.action-feedback button {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #6c757d;\n}\n\n.action-feedback button:hover {\n  color: #343a40;\n}\n\n/* Button Group */\n.button-group {\n  display: flex;\n  gap: 12px;\n}\n\n/* Search Container */\n.search-containers {\n  margin-bottom: 15px;\n  position: relative;\n  max-width: 300px;\n  margin-top: 15px;\n}\n\n/* Sortable Headers */\n.sortable-header {\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.sortable-header:hover {\n  background-color: rgba(79, 70, 229, 0.05);\n}\n\n.sortable-header .flex {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.sortable-header svg {\n  margin-left: 4px;\n  transition: color 0.2s ease;\n}\n\n.import-jira-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: var(--bg-light);\n  border-color: var(--primary);\n  color: var(--primary);\n  border: 1px solid var(--border-color);\n  transition: all 0.2s ease;\n}\n\n/* .import-jira-btn:hover {\n  background-color: var(--bg-light);\n  border-color: var(--primary);\n  color: var(--primary);\n} */\n\n.import-jira-btn svg {\n  color: var(--primary);\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.action-btn {\n   flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-btn:hover {\n  background-color: var(--bg-light);\n  color: var(--text-primary);\n}\n\n.action-btn.view:hover {\n  color: #17a2b8;\n}\n\n.action-btn.edit:hover {\n  color: #28a745;\n}\n\n.action-btn.delete:hover {\n  color: #dc3545;\n}\n\n.action-btn.more {\n  position: relative;\n}\n\n \n.action-dropdown {\n  position: absolute;\n  background-color: white;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  min-width: 160px;\n  padding: 8px 0;\n  z-index: 1000;\n  max-height: min(360px, calc(100vh - 24px));\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.action-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  color: var(--text-primary);\n  text-decoration: none;\n  font-size: 14px;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  background-color: var(--surface);\n}\n\n/* .projects-table tr:nth-last-child(-n+3) .action-dropdown {\n  bottom: 100%;\n  top: auto;\n  margin-top: 0;\n  margin-bottom: 5px;\n} */\n\n\n.action-dropdown.dropdown-above {\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.dropdown-last-rows {\n  bottom: 100%;\n  top: auto !important;\n  margin-top: 0 !important;\n}\n\n.action-dropdown.active {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n\n.action-dropdown-divider {\n  height: 1px;\n  background-color: #eee;\n  margin: 0.25rem 0;\n}\n\n.action-btn-container {\n  position: relative;\n  display: inline-block;\n}\n\n.action-btn-container:hover .action-dropdown {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n\n.action-dropdown:hover {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n\n/* Submenu Styles */\n.action-dropdown-item-with-submenu {\n  position: relative;\n}\n\n.action-dropdown-item.has-submenu {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  width: 100%;\n}\n\n.action-dropdown-item.has-submenu .flex-1 {\n  flex: 1;\n  text-align: left;\n}\n\n.submenu-arrow {\n  margin-left: 8px;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.submenu-arrow.open {\n  transform: rotate(90deg);\n}\n\n.action-submenu {\n  position: static;\n  background-color: #f8f9fa;\n  border-radius: 0;\n  box-shadow: none;\n  min-width: 0;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  border-top: 1px solid #eee;\n  border-bottom: 1px solid #eee;\n  z-index: auto;\n  animation: none;\n}\n\n.action-submenu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px 8px 36px;\n  color: var(--text-primary);\n  text-decoration: none;\n  font-size: 14px;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  transition: background-color 0.15s ease;\n}\n\n.action-submenu-item:hover:not(:disabled) {\n  background-color: #f8f9fa;\n  color: var(--primary);\n}\n\n.action-submenu-item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.action-submenu-item:disabled:hover {\n  background-color: var(--surface);\n  color: var(--text-primary);\n}\n\n.submenu-item-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-badge.status-active {\n  background-color: #e6f4ea;\n  color: #28a745;\n}\n\n.status-badge.status-inactive {\n  background-color: #f8d7da;  \n  color: #dc3545;    \n}\n\n.status-badge.status-completed {\n  background-color: #cff4fc;\n  color: #0dcaf0;\n}\n\n.status-badge.status-archived {\n  background-color: #f8d7da;\n  color: #dc3545;\n}\n\n/* JIRA Status Badge Colors */\n.status-badge.status-todo {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.status-badge.status-inprogress {\n  background-color: #fff3e0;\n  color: #f57c00;\n}\n\n.status-badge.status-done {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-badge.status-blocked {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n/* Projects Table */\n\n\n.projects-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n  table-layout: fixed;\n}\n\n\n.projects-table td:last-child {\n  overflow: visible !important;\n}\n\n.projects-table th {\n  background-color: #f8f9fa;\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border-color);\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n}\n\n.projects-table th:hover {\n  background-color: #e9ecef;\n}\n\n.projects-table tr:last-child td {\n  border-bottom: none;\n}\n\n.projects-table tr:hover {\n  background-color: #f8f9fa;\n  position: relative; /* Add position relative */\n  z-index: 1; /* Lower z-index than the dropdown */\n}\n\n/* Ensure the last cell in each row has a higher z-index */\n.projects-table tr td:last-child {\n  position: relative;\n  z-index: 50;\n}\n\n/* Empty State */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  text-align: center;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  margin-top: 24px;\n}\n\n.empty-state-icon {\n  color: #dee2e6;\n  margin-bottom: 24px;\n}\n\n.empty-state-title {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--text-primary);\n}\n\n.empty-state-description {\n  color: var(--text-muted);\n  margin-bottom: 24px;\n  max-width: 400px;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.projects-container {\n  width: 100%;\n  max-width: 100vw;\n  overflow-x: hidden;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n/* Viewport-fit layout: only the table scrolls; pagination stays on-screen */\n.projects-container.projects-list-layout {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  min-height: 0;\n  overflow: visible;\n}\n\n.projects-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.projects-container.projects-list-layout .projects-header {\n  flex-shrink: 0;\n}\n\n.projects-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--text-dark);\n  margin: 0;\n}\n\n.projects-subtitle {\n  font-size: 1rem;\n  color: var(--text-muted);\n  margin-top: 0.5rem;\n}\n\n.projects-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n/* Filter and Search Section */\n.projects-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.filter-label {\n  font-weight: 500;\n  color: var(--text-dark);\n  white-space: nowrap;\n}\n\n.filter-select {\n  padding: 0.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  min-width: 150px;\n  font-size: 0.9rem;\n}\n\n.search-box {\n  flex-grow: 1;\n  position: relative;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 0.5rem 0.75rem 0.5rem 2.25rem;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.search-icon {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n}\n\n/* Projects Table */\n.projects-table-container {\n  position: relative;\n  z-index: 1;\n\n  width: 100%;\n  margin: 0 0 1rem 0;\n\n  background-color: white;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n\n  min-height: 200px;\n  max-height: 500px;\n\n  overflow-y: auto;\n  overflow-x: auto;\n\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Fill remaining viewport so only the table scrolls; pagination stays visible */\n.projects-container.projects-list-layout > .projects-table-container {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n}\n\n.projects-table {\n  width: 100%;\n  border-collapse: collapse;\n  flex: 1;\n  height: auto; /* Auto height based on content */\n  min-height: 100px; /* Minimum height */\n  table-layout: fixed; /* Fixed table layout for better control */\n}\n\n.projects-table th,\n.projects-table td {\n  padding: 0.5rem 0.5rem 0.5rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color-light);\n  position: static;\n}\n\n.projects-table td .cell-truncate {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.projects-table .column-name {\n  white-space: normal;\n  overflow: hidden;\n}\n\n.projects-table .project-name-text {\n  font-weight: 500;\n}\n\n.projects-table .project-description-text {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n}\n\n.projects-table .column-actions,\n.projects-table .column-actions .action-buttons {\n  overflow: visible;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n\n.projects-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background-color: #f8f9fa;\n}\n\n.projects-table tbody {\n  /* overflow-y: auto; */\n  position: relative;\n  z-index: 1;\n}\n\n.projects-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: var(--text-dark);\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.projects-table td:not(.column-name):not(.column-actions) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.projects-table th.column-srno,\n.projects-table td.column-srno {\n  width: 5%;\n  min-width: 50px;\n  text-align: center;\n}\n\n.projects-table th.column-name,\n.projects-table td.column-name {\n  width: 22%;\n  min-width: 140px;\n}\n\n.projects-table th.column-type,\n.projects-table td.column-type,\n.projects-table th.column-status,\n.projects-table td.column-status {\n  width: 8%;\n  min-width: 72px;\n  text-align: center;\n}\n\n.projects-table th.column-testcases,\n.projects-table td.column-testcases {\n  width: 7%;\n  min-width: 72px;\n  text-align: center;\n}\n\n.projects-table th.column-createdby,\n.projects-table td.column-createdby {\n  width: 11%;\n  min-width: 90px;\n}\n\n.projects-table th.column-created,\n.projects-table td.column-created,\n.projects-table th.column-updated,\n.projects-table td.column-updated {\n  width: 11%;\n  min-width: 100px;\n}\n\n.projects-table th.column-actions,\n.projects-table td.column-actions {\n  width: 148px;\n  min-width: 148px;\n  max-width: 148px;\n  text-align: center;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  overflow: visible;\n}\n\n.projects-table .column-actions .action-buttons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n  width: 100%;\n  margin: 0;\n}\n\n.projects-table th:hover {\n  background-color: #f1f3f5;\n}\n\n.sort-icon {\n  margin-left: 0.25rem;\n  display: inline-block;\n  transition: transform 0.2s ease;\n}\n\n.sort-asc .sort-icon {\n  transform: rotate(180deg);\n}\n\n.projects-table tbody tr {\n  transition: background-color 0.2s ease;\n}\n\n.projects-table tbody tr:hover {\n  background-color: rgba(66, 133, 244, 0.05);\n}\n\n/* Project Status Badges */\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.status-active {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.status-draft {\n  background-color: rgba(108, 117, 125, 0.1);\n  color: #6c757d;\n}\n\n.status-completed {\n  background-color: rgba(23, 162, 184, 0.1);\n  color: #17a2b8;\n}\n\n.status-archived {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n/* Test Cases and Pass Rate Styles */\n.test-cases-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(13, 110, 253, 0.1);\n  color: #0d6efd;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 20px;\n  min-width: 40px;\n}\n\n.pass-rate-high {\n  color: #28a745;\n}\n\n.pass-rate-medium {\n  color: #fd7e14;\n}\n\n.pass-rate-low {\n  color: #dc3545;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  flex-wrap: nowrap;\n   gap: 0.25rem;\n   justify-content: flex-start;\n\n\n}\n\n.action-btn {\n   flex-shrink: 0;\n   background: none;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-muted);\n  transition: all 0.3s ease;\n}\n\n.action-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: var(--text-dark);\n}\n\n.action-btn.edit:hover {\n  color: #0d6efd;\n}\n\n.action-btn.delete:hover {\n  color: #dc3545;\n}\n\n.action-btn.view:hover {\n  color: #20c997;\n}\n\n.action-dropdown-item:hover {\n  background-color: #f8f9fa;\n}\n\n.action-dropdown-item-wrapper {\n  width: 100%;\n}\n\n.action-dropdown-item:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.action-dropdown-item:disabled:hover {\n  background-color: transparent;\n}\n\n/* Add a pseudo-element to create a larger hit area and prevent dropdown from closing */\n/* .action-btn.more::after {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n  display: none;\n} */\n\n/* .action-btn.more:focus::after,\n.action-btn.more:hover::after {\n  display: block;\n}  */\n \n/* Ensure the action button has position relative for proper dropdown positioning */\n \n\n/* Improve dropdown visibility behavior */\n\n/* Keep the old hover behavior as a fallback */\n \n\n/* Ensure the table row doesn't interfere with the dropdown */\n.projects-table tr:hover {\n  z-index: auto !important;\n  position: static !important;\n}\n\n/* Fix for dropdown positioning */\n.projects-table td:last-child {\n  position: relative !important;\n  overflow: visible !important; /* Ensure dropdown isn't cut off */\n}\n\n/* Add a container to ensure proper stacking context */\n/* Container for action buttons */\n.action-buttons {\n  position: relative;\n  z-index: 10;\n}\n\n \n\n/* Dropdown menu container */\n.dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.2); /* subtle darkening */\n  z-index: 9998; /* below the dropdown but above content */\n}\n\n/* Prevent dropdown from being cut off in rows */\n.projects-table tr {\n  position: relative;\n  z-index: 1; /* Normal stacking level */\n}\n\n\n/* Pagination */\n.projects-container.projects-list-layout > .pagination-container {\n  flex-shrink: 0;\n}\n\n.pagination {\n  display: flex;\n  align-items: center;\n  margin-top: auto;\n  padding: 1rem;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.pagination-info {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.pagination-btn {\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  background-color: transparent;\n  color: var(--text-secondary, var(--text-dark));\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.pagination-btn:hover {\n  background-color: var(--surface-hover, #f8f9fa);\n  color: var(--text-primary, var(--text-dark));\n}\n\n.pagination-btn.active {\n  background-color: var(--primary-muted, rgba(37, 99, 235, 0.1));\n  color: var(--primary, var(--primary-color));\n  border-color: transparent;\n}\n\n.pagination-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Empty State */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  text-align: center;\n}\n\n.empty-state-icon {\n  font-size: 4rem;\n  color: var(--border-color);\n  margin-bottom: 1rem;\n}\n\n.empty-state-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-dark);\n  margin-bottom: 0.5rem;\n}\n\n.empty-state-description {\n  color: var(--text-muted);\n  margin-bottom: 1.5rem;\n  max-width: 400px;\n}\n\n/* Responsive Styles */\n@media (max-width: 992px) {\n  .projects-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  \n  .projects-actions {\n    width: 100%;\n  }\n  \n  .projects-filters {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .filter-group {\n    width: 100%;\n  }\n  \n  .filter-select {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .projects-container {\n    padding: 0.5rem;\n    height: auto;\n    min-height: 100vh;\n  }\n\n  .projects-container.projects-list-layout {\n    height: auto;\n    min-height: 0;\n    overflow: visible;\n  }\n  \n  .projects-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n    margin-bottom: 1rem;\n  }\n  \n  .projects-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .projects-filters {\n    padding: 0.75rem;\n  }\n  \n  .projects-table-container {\n    height: auto;\n    min-height: 200px;\n    max-height: none;\n    overflow-x: auto;\n    margin-bottom: 1rem;\n  }\n\n  .projects-container.projects-list-layout > .projects-table-container {\n    min-height: 0;\n    max-height: none;\n  }\n  \n  .projects-table {\n    font-size: 0.9rem;\n  }\n  \n  .projects-table .action-buttons {\n    flex-wrap: nowrap;\n  }\n  \n  .pagination {\n    flex-direction: column;\n    gap: 1rem;\n  }\n}\n\n/* Table Responsive Behavior */\n@media (max-width: 1400px) {\n  .projects-container {\n    padding: 1rem;\n  }\n\n  .projects-table th.column-name,\n  .projects-table td.column-name {\n    width: 18%;\n    min-width: 120px;\n  }\n\n  .projects-table th.column-actions,\n  .projects-table td.column-actions {\n    width: 148px;\n    min-width: 148px;\n    max-width: 148px;\n  }\n}\n\n/* Card View for Mobile */\n@media (max-width: 576px) {\n  .projects-container {\n    padding: 0.5rem;\n    width: 100%;\n    overflow-x: hidden;\n  }\n  \n  .projects-table-container {\n    display: none;\n  }\n  \n  .projects-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    width: 100%;\n    margin-top: 1rem;\n  }\n  \n  .project-card {\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    padding: 1rem;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  \n  .project-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 1rem;\n  }\n  \n  .project-card-title {\n    font-weight: 600;\n    font-size: 1.1rem;\n    color: var(--text-dark);\n    margin: 0;\n  }\n  \n  .project-card-content {\n    display: grid;\n    grid-template-columns: minmax(100px, auto) 1fr;\n    gap: 0.75rem 1rem;\n    margin-bottom: 1rem;\n    width: 100%;\n  }\n  \n  .project-card-label {\n    font-weight: 500;\n    color: var(--text-muted);\n    white-space: nowrap;\n  }\n  \n  .project-card-value {\n    color: var(--text-dark);\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .project-card-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-top: 1px solid var(--border-color-light);\n    padding-top: 1rem;\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  \n  .project-card-actions {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n  }\n  \n  /* Mobile card specific styles for test cases and pass rate */\n  .project-card-value .test-cases-badge {\n    font-size: 0.8rem;\n    padding: 2px 8px;\n  }\n  \n  .project-card-value .progress-bar-container {\n    width: 50px;\n    height: 6px;\n    background-color: #e9ecef;\n    border-radius: 3px;\n    overflow: hidden;\n  }\n  \n  .project-card-value .progress-bar {\n    height: 100%;\n    border-radius: 3px;\n  }\n  \n  .project-card-value .progress-bar.high {\n    background-color: #28a745;\n  }\n  \n  .project-card-value .progress-bar.medium {\n    background-color: #fd7e14;\n  }\n  \n  .project-card-value .progress-bar.low {\n    background-color: #dc3545;\n  }\n}\n\n/* Status Tabs Container */\n.status-tabs-container {\n  margin: 0.75rem 0 1rem 0;\n  /* padding: 0 0.5rem; */\n}\n\n.projects-container.projects-list-layout .status-tabs-container {\n  flex-shrink: 0;\n}\n\n.status-tabs {\n  display: flex;\n  gap: 1px;\n  background-color: #e0e0e0;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.status-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1rem;\n  border: none;\n  background-color: white;\n  color: #666;\n  font-weight: 500;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  min-width: 100px;\n}\n\n.status-tab:hover {\n  background-color: #f5f5f5;\n}\n\n.status-tab.active {\n  background-color: #4361ee;\n  color: white;\n  font-weight: 600;\n}\n\n.tab-label {\n  margin-right: 8px;\n}\n\n.tab-count {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  padding: 2px 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.status-tab.active .tab-count {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n/* Dark mode support */\n.dark-mode .status-tabs {\n  background-color: #333;\n}\n\n.dark-mode .status-tab {\n  background-color: #2d2d2d;\n  color: #ccc;\n}\n\n.dark-mode .status-tab:hover {\n  background-color: #3a3a3a;\n}\n\n.dark-mode .status-tab.active {\n  background-color: #4361ee;\n  color: white;\n}\n\n.dark-mode .tab-count {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.search-input::placeholder {\n  color: gray;\n  opacity: 1; \n}\n\n.no-projects-message {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-muted);\n  font-size: 1.1rem;\n}\n\n.projects-table td > div[title],\n.projects-table td .cell-truncate[title] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  cursor: default;\n}\n\n.projects-table td > div[title]:hover::after,\n.projects-table td .cell-truncate[title]:hover::after {\n  content: attr(title);\n  position: absolute;\n  left: 0;\n  top: 100%;\n  background: rgba(0, 0, 0, 0.85);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  z-index: 1000;\n  white-space: normal;\n  max-width: 300px;\n  word-wrap: break-word;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: none;\n}\n\n.projects-table .column-name td > div[title]:first-child:hover::after,\n.projects-table td.column-name .cell-truncate:first-child:hover::after {\n  top: auto;\n  bottom: 100%;\n  left: 0;\n}\n\n.projects-table td:has(.cell-truncate[title]):hover,\n.projects-table td:has(> div[title]):hover {\n  overflow: visible;\n  z-index: 5;\n}\n\n.projects-table td .cell-truncate[title],\n.projects-table td > div[title] {\n  position: relative;\n}\n\n@media (max-width: 768px) {\n  .projects-table td > div[title]:hover::after {\n    font-size: 0.8rem;\n    max-width: 200px;\n    padding: 0.4rem 0.6rem;\n  }\n}\n\n.table-responsive-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.projects-table {\n  width: 100%;\n}\n\n\n.column-srno { width: 5%; min-width: 50px; }\n.column-name { width: 22%; min-width: 140px; }\n.column-type { width: 8%; min-width: 72px; }\n.column-status { width: 8%; min-width: 72px; }\n.column-testcases { width: 7%; min-width: 72px; }\n.column-createdby { width: 11%; min-width: 90px; }\n.column-created { width: 11%; min-width: 100px; }\n.column-updated { width: 11%; min-width: 100px; }\n.column-actions { width: 148px; min-width: 148px; max-width: 148px; }\n\n\n.projects-cards-container {\n  display: none;\n}\n\n\n@media screen and (max-width: 1400px) {\n  .projects-table {\n    font-size: 0.9rem;\n  }\n\n  .projects-table th,\n  .projects-table td {\n    padding: 0.75rem;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .projects-table-container {\n    overflow-x: auto;\n  }\n\n  .projects-cards-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 1rem;\n  }\n\n  .project-card {\n    background: var(--surface);\n    border-radius: 8px;\n    padding: 1rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 0.75rem;\n  }\n\n  .card-title {\n    margin: 0;\n    font-size: 1.1rem;\n    font-weight: 500;\n    flex: 1;\n    margin-right: 0.5rem;\n  }\n\n  .card-description {\n    color: var(--text-muted);\n    margin-bottom: 1rem;\n    font-size: 0.9rem;\n    line-height: 1.4;\n  }\n\n  .card-details {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n  }\n\n  .card-detail-item {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .detail-label {\n    font-size: 0.8rem;\n    color: var(--text-muted);\n    margin-bottom: 0.25rem;\n  }\n\n  .detail-value {\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n\n  .card-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n  }\n}\n\n\n@media screen and (max-width: 768px) {\n  .projects-cards-container {\n    grid-template-columns: 1fr;\n  }\n  \n  .projects-header {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .status-tabs {\n    flex-wrap: wrap;\n  }\n  \n  .status-tab {\n    flex: 1 0 45%;\n    margin-bottom: 0.5rem;\n  }\n}\n\n\n@media screen and (min-resolution: 200dpi) {\n  .projects-table {\n    font-size: 0.9rem;\n  }\n  \n  .projects-table th,\n  .projects-table td {\n    padding: 0.5rem 0.75rem;\n  }\n}\n\n\n.progress-bar-container {\n  width: 60px;\n  height: 8px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n/* Epics/Stories Page Search Styles */\n.projects-container .navbar-search {\n  position: relative;\n  width: 300px;\n  max-width: 100%;\n}\n\n.projects-container .navbar-search input {\n  width: 100%;\n  padding: 0.5rem 0.75rem 0.5rem 2.25rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: white;\n  color: #333;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.projects-container .navbar-search input::placeholder {\n  color: #999;\n}\n\n.projects-container .navbar-search input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.projects-container .navbar-search-icon {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #666;\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* Generate Tests Button Styles */\n.generate-tests-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  white-space: nowrap;\n}\n\n.generate-tests-btn:hover:not(.loading) {\n  background-color: #0056b3;\n}\n\n.generate-tests-btn.loading {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Spin animation for loading spinner */\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: nowrap;\n}\n\n\n.status-badge {\n  font-size: 0.8rem;\n  padding: 0.25rem 0.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
